module.exports = __webpack_public_path__ + "img/trash-bin.d8655818.svg";